module.exports = __webpack_public_path__ + "static/img/yikaipiao@3x5754561.png";